module.exports = __webpack_public_path__ + "img/16f12199-8f8a-489d-ab0c-f9c32da41927.847d682f.png";